import enums from "./../enums";

const live = (
	state = {
		tournaments: {},
		tournamentLoading: false,
		match: {},
		matchLoading: false,
		scoreboard: {},
	},
	action
) => {
	switch (action.type) {
		case enums.LOADING_LIVE_TOURNAMENT: {
			return { ...state, tournamentLoading: action.payload };
		}
		case enums.LOADING_LIVE_MATCH_LIST: {
			return { ...state, matchLoading: action.payload };
		}
		case enums.LOAD_LIVE_MATCH: {
			return { ...state, match: action.payload };
		}
		case enums.LOAD_LIVE_MATCH_MARKET_DATA: {
			return {
				...state,
				match: { ...state.match, markets: action.payload.markets },
			};
		}
		case enums.TOURNAMENT_LIST_LIVE: {
			return { ...state, tournaments: action.payload };
		}
		case enums.LIVE_SCOREBOARD: {
			return { ...state, scoreboard: action.payload };
		}
		case "ODDS_CHANGE": {
			const updatedMatch = action.msg.match;

			//expensive update
			return {
				...state,
				tournaments: {
					...state["tournaments"],
					sports: state.tournaments.sports.map((sport, index) => {
						if (sport.id !== updatedMatch.sport.id) {
							return sport;
						}

						return {
							...sport,
							categories: sport.categories.map((country) => {
								if (country.id != updatedMatch.category.id) {
									return country;
								}

								return {
									...country,
									tournaments: country.tournaments.map((t) => {
										if (t.id != updatedMatch.tournament.id) {
											return t;
										}

										return {
											...t,
											matches: t.matches.map((m) => {
												if (m.id != updatedMatch.id) {
													return m;
												}

												let prevMQ,
													prevMg,
													prevMw,
													currentMarket1x2 = m.markets[0],
													newSelection = action.msg.markets.find(
														(market) => market.name === "1x2"
													),
													newMatch = { ...m };

												newMatch.score = updatedMatch.score;
												newMatch.marketCount = action.msg.markets.length;
												newMatch.isDisabled = false;

												if (currentMarket1x2 && newSelection) {
													prevMQ = currentMarket1x2.outcomes[0].odds;
													prevMg = currentMarket1x2.outcomes[1].odds;
													prevMw = currentMarket1x2.outcomes[2].odds;
													newSelection.outcomes[0].change =
														newSelection.outcomes[0].odds > prevMQ
															? "up"
															: newSelection.outcomes[0].odds < prevMQ
																? "down"
																: "same";
													newSelection.outcomes[0].change =
														newSelection.outcomes[1].odds > prevMg
															? "up"
															: newSelection.outcomes[1].odds < prevMg
																? "down"
																: "same";
													newSelection.outcomes[0].change =
														newSelection.outcomes[2].odds > prevMw
															? "up"
															: newSelection.outcomes[2].odds < prevMw
																? "down"
																: "same";
													newSelection.isChanged = true;
												}

												return {
													...newMatch,
													markets: [newSelection],
												};
											}),
										};
									}),
								};
							}),
						};
					}),
				},
				match: {
					...state.match,
					markets:
						state.match.id == updatedMatch.id
							? action.msg.markets
							: state.match.markets,
				},
			};
		}

		case "BET_STOP": {
			const updatedMatch = action.msg.match;

			//expensive update
			return {
				...state,
				tournaments: {
					...state["tournaments"],
					sports: state.tournaments.sports.map((sport, index) => {
						if (sport.id !== updatedMatch.sport.id) {
							return sport;
						}

						return {
							...sport,
							categories: sport.categories.map((country) => {
								if (country.id != updatedMatch.category.id) {
									return country;
								}

								return {
									...country,
									tournaments: country.tournaments.map((t) => {
										if (t.id != updatedMatch.tournament.id) {
											return t;
										}

										return {
											...t,
											matches: t.matches.map((m) => {
												if (m.id != updatedMatch.id) {
													return m;
												}

												let newMatch = { ...m };
												newMatch.score = updatedMatch.score;
												newMatch.isDisabled = true;

												return {
													...newMatch,
												};
											}),
										};
									}),
								};
							}),
						};
					}),
				},
			};
		}
		default:
			return { ...state };
	}
};

export default live;
